'use strict';

import React from 'external/react';
import ReactDOM from 'external/react-dom';
import PropTypes from 'external/prop-types';

import { TitleContainerContext } from './CustomModalComponents';

const SimpleTitle = ({ title, id, icon, additionalText, listAdd, plain }) => {

    if (plain) {
        return <React.Fragment>
            {icon && icon}
            <span className={"title"}>{title + (additionalText ? (' (' + additionalText + ')') : '')}</span>
            {listAdd && listAdd}
            {id ? <span className="stat-percent text-navy">#{id}</span> : null}
        </React.Fragment>;
    }

    return (
        <div className="ibox-heading fullwidth">
            <h3 className="widget-title">
                {icon && icon}
                {title + (additionalText ? (' (' + additionalText + ')') : '')}
                {listAdd && listAdd}
                {id ? <span className="stat-percent text-navy">#{id}</span> : null}
            </h3>
        </div>
    );
};


class Title extends React.Component {

    componentDidUpdate(prevProps) {
        if (this.props.title !== prevProps.title) {
            this.renderTitle();
        }
    }

    attach(ref) {
        let elem = ref;
        for (; elem && elem !== document; elem = elem.parentNode) {
            if (elem.classList.contains('portlet-container')) {
                const titles = elem.getElementsByClassName('portlet-subtitle');//portlet-title-text
                if (titles.length > 0) {
                    this.titleElement = titles[ 0 ];
                    this.renderTitle();
                    return;
                }
            }
        }
        console.warn('No portlet title element found!');
    }

    renderTitle() {
        if (this.titleElement) {
            this.titleElement.innerHTML = this.props.title;
        }
    }

    render() {
        const { children } = this.props;

        return (
            <TitleContainerContext.Consumer>
                {
                    titleRef => {
                        if (titleRef) {
                            this.titleRef = titleRef;
                            if (React.Children.count(children) > 0) {
                                return ReactDOM.createPortal(children, titleRef)
                            }

                            return ReactDOM.createPortal(<SimpleTitle {...this.props} plain/>, titleRef)
                        }

                        return <SimpleTitle {...this.props}/>
                    }
                }
            </TitleContainerContext.Consumer>)
    }
}

SimpleTitle.propTypes = {
    title: PropTypes.string.isRequired,
    additionalText: PropTypes.string,
    icon: PropTypes.oneOfType([ PropTypes.object, PropTypes.string ]),
    id: PropTypes.number,
    header: PropTypes.bool,
    children: PropTypes.oneOfType([ PropTypes.element, PropTypes.array ])
};

Title.propTypes = {
    ...SimpleTitle.propTypes
};

export default Title;



// WEBPACK FOOTER //
// ./js/components/Title.jsx